import { ActionType } from "@sp-crm/core";
import { Feature } from "components/feature";
import * as React from "react";
import { Redirect, useParams } from "react-router-dom";
import { useIsAllowed } from "store/selectors/hooks";
import { CustomReports } from "./custom-reports";
import { FranchiseRoyalties } from "./franchise-royalties";
import { OutstandingInvoices } from "./outstanding-invoices";
import { ReferralSource } from "./referral-source";
import { Referrals } from "./referrals";
import { ClientPlacementRevenue } from "./revenue";
import { StageConversion } from "./stage-conversion";
import { Summary } from "./summary";
import { TimeTracking } from "./time-tracking";

export const ReportsShow: React.FC = () => {
    const params = useParams<{ reportname?: string }>();
    const reportName = params.reportname || "summary";
    const canViewReports = useIsAllowed(ActionType.ViewReports);

    if (reportName === "custom") {
        return <CustomReports />;
    }

    if (!canViewReports) {
        return <Redirect to="/reports/show/custom" />;
    }

    if (reportName === "summary") {
        return (
            <Feature name="placement">
                <Summary />
            </Feature>
        );
    }

    if (reportName === "revenue") {
        return (
            <Feature name="placement">
                <ClientPlacementRevenue />
            </Feature>
        );
    }

    if (reportName === "inbound-referrals" || reportName === "referrals") {
        return (
            <Feature name="placement">
                <Referrals />
            </Feature>
        );
    }

    if (reportName === "referral-source") {
        return (
            <Feature name="placement">
                <Feature name="referralSourceReport">
                    <ReferralSource />
                </Feature>
            </Feature>
        );
    }

    if (reportName === "stage-conversion") {
        return (
            <Feature name="placement">
                <Feature name="stageConversion">
                    <StageConversion />
                </Feature>
            </Feature>
        );
    }

    if (reportName === "franchise-royalties") {
        return (
            <Feature name="franchiseManagement">
                <FranchiseRoyalties />
            </Feature>
        );
    }

    if (reportName === "outstanding-invoices") {
        return (
            <Feature name="placement">
                <Feature name="outstandingInvoicesReport">
                    <OutstandingInvoices />
                </Feature>
            </Feature>
        );
    }

    if (reportName === "time-tracking") {
        return (
            <Feature name="trackTime">
                <TimeTracking />
            </Feature>
        );
    }

    return <h2>Sorry, no report found</h2>;
};
